/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, ElementRef, Renderer, ViewEncapsulation, HostBinding } from '@angular/core';
import { AfterViewInit, ContentChild } from '@angular/core';
import classNames from 'classnames';

import { AvatarText } from './avatar.text';
/**
 * Avatar头像
 * 用来代表用户或事物，支持图片、图标或字符展示。
 */
export class Avatar implements AfterViewInit {
/**
 * 样式前缀
 */
prefixCls = 'ant-avatar';
/**
 * 指定头像的形状; Shape of avatar, options:`circle`, `square`
 */
shape: 'circle' | 'square' = 'circle';
/**
 * 设置头像的大小; Size of avatar, options:`large`, `small`, `default`
 */
size: 'large' | 'small' | 'default' = 'default';
/**
 * 图片类头像的资源地址; Src of image avatar
 */
src: string;
/**
 * 设置头像的图标类型，参考 `Icon` 组件; Type of the Icon to be used in avatar
 */
icon: string;
/**
 * 用户CSS样式
 */
class: string;

     text: AvatarText;
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 */
constructor(private _renderer: Renderer,
private _elementRef: ElementRef) {

    }
/**
 * @return {?}
 */
ngAfterViewInit(): void {
        if (this.text) {
            const /** @type {?} */ textEl = this.text.getHostElement();
            this._renderer.setElementClass(textEl, `${this.prefixCls}-string`, true);
        }
    }
/**
 * @return {?}
 */
get classes(): string {
        const /** @type {?} */ classString = classNames(this.prefixCls, {
            [`${this.prefixCls}-${this.shape}`]: this.shape,
            [`${this.prefixCls}-image`]: this.src,
            [`${this.prefixCls}-icon`]: this.icon,
            [`${this.prefixCls}-lg`]: this.size === 'large',
            [`${this.prefixCls}-sm`]: this.size === 'small'
        }, this.class);

        return classString;
    }
/**
 * The underlying host native element
 * @return {?}
 */
getHostElement(): HTMLElement {
        return /** @type {?} */(( this._elementRef.nativeElement as HTMLElement));
    }
/**
 * @return {?}
 */
getScale(): number {
        const /** @type {?} */ textEl = this.text && this.text.getHostElement();
        const /** @type {?} */ textWidth = textEl ? textEl.offsetWidth : 16;
        const /** @type {?} */ totalWidth = this.getHostElement().offsetWidth;

        let /** @type {?} */ scale = 1;
        // add 4px gap for each side to get better performance
        if (totalWidth - 8 < textWidth) {
            scale = (totalWidth - 8) / textWidth;
        }
        return scale;
    }
/**
 * @return {?}
 */
getTextNodeStyle(): any {
        const /** @type {?} */ textEl = this.text && this.text.getHostElement();
        const /** @type {?} */ width = textEl ? textEl.offsetWidth : 16;
        const /** @type {?} */ scale = this.getScale(); // 放大或缩小的倍数

        return {
            '-ms-transform': `scale(${scale})`,
            '-webkit-transform': `scale(${scale})`,
            'transform': `scale(${scale})`,
            'position': 'absolute',
            'display': 'inline-block',
            'left': `calc(50% - ${Math.round(width / 2)}px)`
        };
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-avatar',
    template: `
        <img [src]="src" *ngIf="src" />
        <ant-icon [type]="icon" *ngIf="icon"></ant-icon>
        <span *ngIf="text" [ngStyle]="getTextNodeStyle()">
            <ng-content select="ant-avatar-text"></ng-content>
        </span>
    `,
    styleUrls: ['./style/index.scss'],
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'shape': [{ type: Input },],
'size': [{ type: Input },],
'src': [{ type: Input },],
'icon': [{ type: Input },],
'class': [{ type: Input },],
'text': [{ type: ContentChild, args: [AvatarText, ] },],
'classes': [{ type: HostBinding, args: ['class', ] },],
};
}

function Avatar_tsickle_Closure_declarations() {
/** @type {?} */
Avatar.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Avatar.ctorParameters;
/** @type {?} */
Avatar.propDecorators;
/**
 * 样式前缀
 * @type {?}
 */
Avatar.prototype.prefixCls;
/**
 * 指定头像的形状; Shape of avatar, options:`circle`, `square`
 * @type {?}
 */
Avatar.prototype.shape;
/**
 * 设置头像的大小; Size of avatar, options:`large`, `small`, `default`
 * @type {?}
 */
Avatar.prototype.size;
/**
 * 图片类头像的资源地址; Src of image avatar
 * @type {?}
 */
Avatar.prototype.src;
/**
 * 设置头像的图标类型，参考 `Icon` 组件; Type of the Icon to be used in avatar
 * @type {?}
 */
Avatar.prototype.icon;
/**
 * 用户CSS样式
 * @type {?}
 */
Avatar.prototype.class;
/** @type {?} */
Avatar.prototype.text;
/** @type {?} */
Avatar.prototype._renderer;
/** @type {?} */
Avatar.prototype._elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
